module.exports = __webpack_public_path__ + "img/hest2.81029c36.jpg";